export default __webpack_public_path__ + "static/media/Chello-Logo.2fb1e519.jpg";